import * as Yup from "yup";

const phoneRegExp = /^(\+|0)[0-9\s]{6,18}$/;

const schema = Yup.object().shape({
  emailAddress: Yup.string().email().required("Obavezno polje"),
  phoneNumber: Yup.string()
    .required("Obavezno polje")
    .matches(
      phoneRegExp,
      "Broj telefona mora početi sa + ili 0 i može sadržati samo brojeve"
    ),
  name: Yup.string().required("Obavezno polje"),
  surname: Yup.string().required("Obavezno polje"),
});

export const validator = {
  async validator({ field }: any, value: any) {
    await schema.validateSyncAt(field, { [field]: value });
  },
};
